import SelectInput from 'components/inputs/selectInput';
import TextInput from 'components/inputs/textInput';
import { StoragesSortBy } from 'hooks/useStorages';
import { SortDirection } from 'types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Collapse from '@/components/collapse/Collapse';
import { ReactComponent as FilterIcon } from '@/assets/icons/filter.svg';
import InputGroup from '@/components/inputs/InputGroup';
import ToggleInput from '@/components/inputs/toggleInput';

type StoragesFilterProps = {
    sortBy: StoragesSortBy;
    setSortBy: (col: StoragesSortBy) => void;
    sortDirection: SortDirection;
    setSortDirection: (dir: SortDirection) => void;
    filterQuery: string;
    setFilterQuery: (val: string) => void;
    displayDeleted: boolean;
    setDisplayDeleted: (val: boolean) => void;
    isLoading?: boolean;
};

const StoragesFilter: React.FC<StoragesFilterProps> = ({
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
    filterQuery,
    setFilterQuery,
    displayDeleted,
    setDisplayDeleted,
    isLoading = false
}) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-y-4">
            <Collapse textOpen={t(`labelHideFilters`)} textClosed={t(`labelShowFilters`)} icon={<FilterIcon />} hideToggleArrow={true}>
                <TextInput
                    label={t('labelFilterKeywords')}
                    value={filterQuery}
                    onChange={e => setFilterQuery(e.target.value)}
                    disabled={isLoading}
                />
                <InputGroup>
                    {/* Sorting column select */}
                    <SelectInput
                        label={t('labelSortBy')}
                        value={sortBy}
                        onChange={e => setSortBy(e.target.value as StoragesSortBy)}
                        disabled={isLoading}
                    >
                        <option value={StoragesSortBy.NAME}>{t('columnName')}</option>
                        <option value={StoragesSortBy.LOCATION}>{t('columnLocation')}</option>
                        <option value={StoragesSortBy.DESCRIPTION}>{t('columnDescription')}</option>
                    </SelectInput>
                    {/* Sorting direction select */}
                    <SelectInput
                        label={t('labelSortDirection')}
                        value={sortDirection}
                        onChange={e => setSortDirection(e.target.value as SortDirection)}
                        disabled={isLoading}
                    >
                        <option value={SortDirection.ASCENDING}>{t('labelAscending')}</option>
                        <option value={SortDirection.DESCENDING}>{t('labelDescending')}</option>
                    </SelectInput>
                </InputGroup>
                <ToggleInput 
                    label={t('labelDisplayDeleted')} 
                    checked={displayDeleted} 
                    onChange={e => setDisplayDeleted(e.target.checked)} 
                    disabled={isLoading} 
                />
            </Collapse>
        </div>
    );
};

export default StoragesFilter;

